import { render, staticRenderFns } from "./confirm-modal.vue?vue&type=template&id=2908ea5a&scoped=true"
import script from "./confirm-modal.vue?vue&type=script&lang=js"
export * from "./confirm-modal.vue?vue&type=script&lang=js"
import style0 from "./confirm-modal.vue?vue&type=style&index=0&id=2908ea5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908ea5a",
  null
  
)

export default component.exports